import { useLanguage } from "@/i18n";

export const extra = {
  en: {
    contact: {
      label: "Visit the shop",
      title: "Come see us in Peabody.",
      sub: "Walk-ins welcome during business hours. Prefer we come to you? Our mobile units cover all of Greater Boston.",
      directions: "Get directions",
      call: "Call us",
    },
    cityPage: {
      eyebrow: "Service area · Greater Boston",
      h1a: "Auto glass in {city}, MA —",
      h1b: "done right.",
      intro: "From our shop at 98 Foster St in Peabody — about {drive} min away — ClearRoute brings premium windshield repair and replacement to {city}. Our mobile units come to your home, office or curbside, and most insurance claims carry a $0 deductible.",
      introHomebase: "Our home base. The ClearRoute shop sits right here at 98 Foster St — walk in, or let a mobile unit come to your driveway, office or curbside. Most insurance claims carry a $0 deductible.",
      servicesTitle: "What we fix in {city}",
      ctaQuote: "Get my instant quote",
      ctaWhats: "WhatsApp us",
      otherTitle: "We also serve",
      back: "Back to home",
      metaTitle: "Auto Glass Repair & Replacement in {city}, MA | ClearRoute Auto Glass",
    },
  },
  pt: {
    contact: {
      label: "Visite a loja",
      title: "Venha nos ver em Peabody.",
      sub: "Atendemos sem agendamento no horário comercial. Prefere que a gente vá até você? Nossas unidades móveis cobrem toda Greater Boston.",
      directions: "Como chegar",
      call: "Ligar agora",
    },
    cityPage: {
      eyebrow: "Área de atendimento · Greater Boston",
      h1a: "Vidros de auto em {city}, MA —",
      h1b: "feitos direito.",
      intro: "Da nossa loja na 98 Foster St em Peabody — a cerca de {drive} min — a ClearRoute leva reparo e troca de para-brisa premium até {city}. Nossas unidades móveis vão à sua casa, trabalho ou onde o carro estiver, e a maioria dos seguros tem franquia $0.",
      introHomebase: "Nossa casa. A loja ClearRoute fica aqui mesmo, na 98 Foster St — chegue sem agendar, ou deixe que uma unidade móvel vá até sua garagem, trabalho ou rua. A maioria dos seguros tem franquia $0.",
      servicesTitle: "O que resolvemos em {city}",
      ctaQuote: "Quero meu orçamento",
      ctaWhats: "Chamar no WhatsApp",
      otherTitle: "Também atendemos",
      back: "Voltar ao início",
      metaTitle: "Reparo e Troca de Para-brisa em {city}, MA | ClearRoute Auto Glass",
    },
  },
  es: {
    contact: {
      label: "Visita la tienda",
      title: "Ven a vernos en Peabody.",
      sub: "Atendemos sin cita en horario laboral. ¿Prefieres que vayamos a ti? Nuestras unidades móviles cubren todo Greater Boston.",
      directions: "Cómo llegar",
      call: "Llamar ahora",
    },
    cityPage: {
      eyebrow: "Área de servicio · Greater Boston",
      h1a: "Vidrios de auto en {city}, MA —",
      h1b: "bien hecho.",
      intro: "Desde nuestra tienda en 98 Foster St en Peabody — a unos {drive} min — ClearRoute lleva reparación y reemplazo de parabrisas premium a {city}. Nuestras unidades móviles van a tu casa, oficina o donde esté el auto, y la mayoría de los seguros tiene deducible de $0.",
      introHomebase: "Nuestra casa. La tienda ClearRoute está justo aquí, en 98 Foster St — ven sin cita, o deja que una unidad móvil vaya a tu garage, oficina o calle. La mayoría de los seguros tiene deducible de $0.",
      servicesTitle: "Lo que arreglamos en {city}",
      ctaQuote: "Quiero mi cotización",
      ctaWhats: "WhatsApp",
      otherTitle: "También servimos",
      back: "Volver al inicio",
      metaTitle: "Reparación y Reemplazo de Parabrisas en {city}, MA | ClearRoute Auto Glass",
    },
  },
};

export const useT = () => {
  const { t, lang } = useLanguage();
  return { ...t, ...(extra[lang] || extra.en) };
};
